import { Button } from '@automata/ui';
import Stack from '@mui/material/Stack';

import PreviewMetrics from './PreviewMetrics';
import { MaybeWorkflowConfig } from '../../features/workflowJsonSelectors';
import { toPreviewBlockers } from '../../utils/previewBlockers';
import ReplanWarning from '../ReplanWarning';

type Props = {
  workflowJson: MaybeWorkflowConfig;
  onClickCreatePlan: () => void;
  disabledCreatePlan: boolean;
  isLoadingCreatePlan: boolean;
  estimatedRuntime: number;
  oldPlanExists: boolean;
  batches: number | null;
};

const SimulationToolbar = ({
  workflowJson,
  onClickCreatePlan,
  disabledCreatePlan,
  isLoadingCreatePlan,
  estimatedRuntime,
  oldPlanExists,
  batches,
}: Props) => {
  return (
    <Stack direction="row" p={3} justifyContent="space-between">
      <PreviewMetrics estimatedRuntime={estimatedRuntime} batches={batches} />
      <Stack direction="row" alignItems="center" gap={1}>
        <Stack direction="row" gap={2}>
          {/*
            // TODO(LT, 04/09/2024): hiding for now, will be re-enabled in a future PR
            <ViewSelector
              onChange={setSelectedView}
              selectedView={selectedView}
            />

            <Divider orientation="vertical" variant="middle" flexItem />
          */}
          <Button
            variant="contained"
            color="secondary"
            onClick={onClickCreatePlan}
            loading={isLoadingCreatePlan}
            disabled={disabledCreatePlan}
          >
            Save and plan
          </Button>
        </Stack>
        {oldPlanExists && (
          <ReplanWarning
            previewBlockers={toPreviewBlockers(workflowJson)}
            title="Something blocks you from replanning."
          />
        )}
      </Stack>
    </Stack>
  );
};

export default SimulationToolbar;
